/**
 * Quick Buy Popup
 * - Fetches product JSON on button click
 * - Renders variant pill/swatch selector
 * - Add to Cart: AJAX + opens Cheekee cart slider
 * - Buy Now: AJAX add then redirect to /checkout
 */

/* ── Cheekee cart slider: shared helpers (main cart for the whole store) ── */
window.ckOpenCartSlider = function () {
  const triggers = Array.from(document.querySelectorAll('[data-ck-cart-open]'));
  const trigger = triggers.find(el => el.offsetParent !== null) || triggers[0];
  if (!trigger) return false;
  trigger.click(); // handled by sections/cheekee-cart-drawer.liquid
  return true;
};

/* Keep the "Your cart is empty" message in sync with the cart contents */
document.addEventListener('cart:updated', function () {
  const drawer = document.querySelector('[data-ck-cart-drawer]');
  if (!drawer) return;
  const form  = drawer.querySelector('#cart-form');
  const empty = drawer.querySelector('.cp-empty');
  if (form && empty) empty.hidden = !form.hidden;
});

/* Cart slider: smooth slide, fixed checkout footer, side close arrow */
(function () {
  const panel = document.querySelector('[data-ck-cart-drawer] .ck-cart-panel');
  if (!panel) return;

  const style = document.createElement('style');
  style.textContent = `
    .ck-cart-drawer { transition: visibility 0s linear .36s !important; }
    .ck-cart-drawer.is-open { transition-delay: 0s !important; }
    .ck-cart-drawer .ck-cart-backdrop {
      -webkit-backdrop-filter: none !important;
      backdrop-filter: none !important;
      transition: opacity .36s ease !important;
    }
    .ck-cart-drawer .ck-cart-panel {
      overflow: visible !important;
      transition: transform .36s cubic-bezier(.32,.72,0,1) !important;
      will-change: transform;
    }

    /* Total + checkout stay fixed at the bottom while items scroll */
    .ck-cart-drawer #cart-form { flex: 1 0 auto !important; }
    .ck-cart-drawer .cp-layout > div:last-child {
      position: sticky; bottom: 0; z-index: 15; margin-top: auto; background: #fff;
    }
    .ck-cart-drawer .cs { position: static !important; }

    /* Free gift banner sits above the checkout footer */
    .ck-cart-drawer .fb-offer {
      bottom: calc(100px + env(safe-area-inset-bottom, 0px)) !important;
      border-radius: 12px !important;
    }
    .ck-cart-drawer .fb-offer:not(.on) { visibility: hidden; }

    .ck-cart-arrow {
      position: absolute; top: 50%; left: -20px; z-index: 30;
      width: 40px; height: 40px; padding: 0;
      display: grid; place-items: center;
      border: 0; border-radius: 50%;
      background: #fff; color: #ff026d;
      box-shadow: 0 2px 12px rgba(0,0,0,.22);
      transform: translateY(-50%);
      cursor: pointer;
    }
    .ck-cart-arrow svg {
      width: 18px; height: 18px; fill: none; stroke: currentColor;
      stroke-width: 2.4; stroke-linecap: round; stroke-linejoin: round;
    }
    @media (prefers-reduced-motion: reduce) {
      .ck-cart-drawer, .ck-cart-drawer .ck-cart-backdrop, .ck-cart-drawer .ck-cart-panel {
        transition: none !important;
      }
    }`;
  document.head.appendChild(style);

  /* data-ck-cart-close is handled by sections/cheekee-cart-drawer.liquid */
  const arrow = document.createElement('button');
  arrow.type = 'button';
  arrow.className = 'ck-cart-arrow';
  arrow.setAttribute('data-ck-cart-close', '');
  arrow.setAttribute('aria-label', 'Close cart');
  arrow.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"></path></svg>';
  panel.appendChild(arrow);

  /* The /cart page sends shoppers back here: see sections/cart-redirect.liquid */
  try {
    if (sessionStorage.getItem('ckOpenCart')) {
      sessionStorage.removeItem('ckOpenCart');
      window.ckOpenCartSlider();
    }
  } catch (e) {}
})();

(function () {
  'use strict';

  /* ── DOM: inject the modal once ── */
  const overlay = document.createElement('div');
  overlay.id    = 'qb-overlay';
  overlay.className = 'qb-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Quick Buy');
  overlay.innerHTML = `
    <div class="qb-modal" id="qb-modal">
      <span class="qb-handle"></span>
      <button class="qb-close" id="qb-close" aria-label="Close quick buy">&times;</button>
      <div id="qb-body"><div class="qb-loading">Loading product…</div></div>
    </div>`;
  document.body.appendChild(overlay);

  /* ── State ── */
  let product        = null;   // current product JSON
  let selectedOpts   = [];     // array of selected option values

  /* ── Helpers ── */
  function formatMoney(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    return (cents / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function getMatchingVariant() {
    if (!product) return null;
    return product.variants.find(v =>
      product.options.every((_, i) => v['option' + (i + 1)] === selectedOpts[i])
    ) || null;
  }

  /* ── Modal open / close ── */
  function openModal() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.getElementById('qb-close').focus();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    product      = null;
    selectedOpts = [];
  }

  /* ── Close triggers ── */
  document.getElementById('qb-close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  /* ── Trigger: delegate from product grid ── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quick-buy-trigger');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.handle;
    if (handle) loadProduct(handle);
  });

  /* ── Fetch product JSON ── */
  async function loadProduct(handle) {
    openModal();
    document.getElementById('qb-body').innerHTML =
      '<div class="qb-loading">Loading product…</div>';

    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      product = await res.json();

      // Pre-select first available variant's options
      selectedOpts = product.options.map(() => null);
      const firstAvailable = product.variants.find(v => v.available);
      const seed = firstAvailable || product.variants[0];
      if (seed) {
        product.options.forEach((_, i) => {
          selectedOpts[i] = seed['option' + (i + 1)];
        });
      }

      renderModal();
    } catch (err) {
      document.getElementById('qb-body').innerHTML =
        '<div class="qb-loading">Could not load product. Please try again.</div>';
    }
  }

  /* ── Render modal content ── */
  function renderModal() {
    const p       = product;
    const variant = getMatchingVariant();
    const price   = variant ? variant.price         : p.price;
    const compare = variant ? variant.compare_at_price : p.compare_at_price;
    const avail   = variant ? variant.available     : false;
    const allSet  = selectedOpts.every(o => o !== null);

    /* Price HTML */
    let priceHtml;
    if (compare && compare > price) {
      priceHtml = `<span class="qb-compare-price">${formatMoney(compare)}</span>`
                + `<span class="qb-sale-price">${formatMoney(price)}</span>`;
    } else {
      priceHtml = `<span>${formatMoney(price)}</span>`;
    }

    /* Image */
    const imgSrc = p.featured_image || (p.images && p.images[0]);
    const imgHtml = imgSrc
      ? `<img class="qb-product-image" src="${imgSrc}" alt="${escHtml(p.title)}">`
      : '';

    /* Options */
    let optionsHtml = '';
    if (!(p.options.length === 1 && p.options[0] === 'Title')) {
      p.options.forEach((optName, optIdx) => {
        const values = [...new Set(p.variants.map(v => v['option' + (optIdx + 1)]))];
        const selVal = selectedOpts[optIdx];

        const pillsHtml = values.map(val => {
          /* A pill is available if ANY variant with this value (and other
             currently-selected options) is available */
          const isAvail = p.variants.some(v => {
            if (v['option' + (optIdx + 1)] !== val) return false;
            if (!v.available) return false;
            return p.options.every((_, i) => {
              if (i === optIdx) return true;
              return !selectedOpts[i] || v['option' + (i + 1)] === selectedOpts[i];
            });
          });
          const isSel = val === selVal;
          const cls   = ['qb-pill',
            isSel     ? 'is-selected' : '',
            !isAvail  ? 'is-disabled' : '',
          ].filter(Boolean).join(' ');

          return `<button class="${cls}"
                    data-opt-idx="${optIdx}"
                    data-value="${escAttr(val)}"
                    ${!isAvail ? 'aria-disabled="true"' : ''}
                  >${escHtml(val)}</button>`;
        }).join('');

        optionsHtml += `
          <div class="qb-option-group">
            <div class="qb-option-header">
              <span class="qb-option-name">${escHtml(optName)}</span>
              <span class="qb-option-selected" id="qb-sel-${optIdx}">${selVal ? escHtml(selVal) : ''}</span>
            </div>
            <div class="qb-pills">${pillsHtml}</div>
          </div>`;
      });
    }

    /* Unavailable notice */
    const unavailHtml = (!avail && allSet)
      ? '<p class="qb-unavailable">This combination is currently unavailable.</p>'
      : '';

    document.getElementById('qb-body').innerHTML = `
      <div class="qb-product-header">
        ${imgHtml}
        <div class="qb-product-info">
          <h2 class="qb-product-title">${escHtml(p.title)}</h2>
          <div class="qb-product-price">${priceHtml}</div>
        </div>
      </div>
      <div class="qb-divider"></div>
      ${optionsHtml}
      ${unavailHtml}
      <div class="qb-actions">
        <button class="qb-btn qb-btn-cart"    id="qb-btn-cart"    ${!avail || !allSet ? 'disabled' : ''}>Add to Cart</button>
        
      </div>
      <div class="qb-status" id="qb-status" aria-live="polite"></div>`;

    /* Pill click handlers */
    document.querySelectorAll('#qb-body .qb-pill:not(.is-disabled)').forEach(pill => {
      pill.addEventListener('click', function () {
        selectedOpts[parseInt(this.dataset.optIdx)] = this.dataset.value;
        renderModal();
      });
    });

    document.getElementById('qb-btn-cart')   ?.addEventListener('click', handleAddToCart);
    document.getElementById('qb-btn-buynow') ?.addEventListener('click', handleBuyNow);
  }

  /* ── Add to Cart (AJAX) ── */
  async function handleAddToCart() {
    const variant = getMatchingVariant();
    if (!variant) return;

    const btn = document.getElementById('qb-btn-cart');
    const status = document.getElementById('qb-status');
    btn.disabled     = true;
    btn.textContent  = 'Adding…';
    status.className = 'qb-status';
    status.textContent = '';

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify({ id: variant.id, quantity: 1 }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart.');
      }

      btn.textContent = 'Added ✓';
      status.className = 'qb-status success';
      status.textContent = 'Item added to your cart!';

      /* Close first so the popup does not reset the slider's scroll lock */
      closeModal();
      openCartDrawer();
    } catch (err) {
      btn.disabled    = false;
      btn.textContent = 'Add to Cart';
      status.className = 'qb-status error';
      status.textContent = err.message || 'Something went wrong. Please try again.';
    }
  }

  async function handleBuyNow() {
  const variant = getMatchingVariant();
  if (!variant) return;

  const btn = document.getElementById('qb-btn-buynow');
  btn.disabled = true;
  btn.textContent = 'Processing…';

  try {
    // 1. Clear cart first and wait
    await fetch('/cart/clear.js', { method: 'POST' });

    // 2. Add the selected variant
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1 }),
    });
    if (!addRes.ok) throw new Error('Failed to add to cart');

    // 3. Close the quick buy modal first
    closeModal();

    // 4. Try to click the real checkout button GoKwik is hooked to
    //    (GoKwik intercepts clicks on these elements)
    const gkTrigger =
      document.querySelector('a[href="/checkout"]') ||
      document.querySelector('button[name="checkout"]') ||
      document.querySelector('.cart__checkout-button') ||
      document.querySelector('[data-checkout-btn]');

    if (gkTrigger) {
      gkTrigger.click(); // GoKwik will intercept this
    } else {
      // Fallback: direct redirect (GoKwik should still intercept)
      window.location.href = '/checkout';
    }

  } catch (e) {
    btn.disabled = false;
    btn.textContent = 'Buy Now';
  }
}

  /* ── Open cart drawer ── */
  function openCartDrawer() {
    /* 1. Cheekee cart slider */
    if (window.ckOpenCartSlider()) return;

    /* 2. Dawn v2+: cart-drawer web component */
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      if (typeof drawerEl.open === 'function') {
        drawerEl.open();
        return;
      }
      /* Dawn fires a custom event to refresh the drawer */
      drawerEl.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    /* 3. Trigger by clicking the cart icon if nothing else works */
    const cartOpener = document.querySelector('[data-cart-toggle], [aria-controls="cart-drawer"], .cart-icon-bubble, .header__icon--cart');
    if (cartOpener) {
      cartOpener.click();
      return;
    }

    /* 4. Fallback: fire a page-level event (some themes listen) */
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:open', { bubbles: true })
    );
  }

  /* ── Small XSS helpers ── */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function escAttr(str) {
    return String(str).replace(/"/g, '&quot;');
  }

})();
